import http from '@/util/http'
// 待反馈列表根据询价状态条件模糊搜索
export function queryAllOrderManuallnquiry (miState, page, size, data) {
  return http({
    url: `/api/orderManualInquiry/queryAllOrderManuallnquiry/${miState}/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 操作询价状态 认领
export function updateByMiState (operate, data) {
  return http({
    url: `/api/orderManualInquiry/updateByMiState/${operate}`,
    method: 'post',
    data
  })
}
// 操作询价状态 提取
export function updateByMiStateExtract (omiId, operate) {
  return http({
    url: `/api/orderManualInquiry/updateByMiStateExtract/${omiId}/${operate}`,
    method: 'post'
  })
}
// 操作配货状态
export function updateByProcessState (operate, data) {
  return http({
    url: `/api/orderContractStockup/updateByProcessState/${operate}`,
    method: 'post',
    data
  })
}
// 操作配货状态
export function updateByProcessStateExtract (psbId, operate) {
  return http({
    url: `/api/orderContractStockup/updateByProcessStateExtract/${psbId}/${operate}`,
    method: 'post'
  })
}
// 根据采购人工询价详情表id获取产品信息
export function queryByomiId (omiId) {
  return http({
    url: `/api/orderManualInquiry/queryByomiId/${omiId}`,
    method: 'post'
  })
}
// 根据询价详情产品id获取所有供应商报价
export function querySystemOfferByProId (proId, page, size, data) {
  return http({
    url: `/api/orderManualInquiry/querySystemOfferByProId/${proId}/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 询价产品详情-上线产品获取供应商
export function querySupplierBaseBySuName (page, size, data) {
  return http({
    url: `/api/orderManualInquiry/querySupplierBaseBySuName/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 询价采购反馈添加供应商
export function addSupplier (data) {
  return http({
    url: '/api/orderManualInquiry/addSupplier',
    method: 'post',
    data: data
  })
}
// 询价产品-新增产品
export function addInquiryByProduct (data) {
  return http({
    url: '/api/orderManualInquiry/addByProduct',
    method: 'post',
    data: data
  })
}
// 合同预览-采购
export function queryUploadPcb (pcbId) {
  return http({
    url: `/api/purchaseContractBase/queryUploadPcb/${pcbId}`,
    method: 'post'
  })
}
export function uploadDown (data) {
  return http({
    url: data,
    method: 'post',
    responseType: 'blob'
  })
}
// 品牌系数导出
export function brandBaseCoeDerive (data) {
  return http({
    url: '/api/brandBase/brandBaseCoeDerive',
    method: 'post',
    data: data,
    responseType: 'blob'
  })
}
// 系列系数导出
export function brandSeriesCoeDerive (data) {
  return http({
    url: '/api/brandSeries/brandSeriesCoeDerive',
    method: 'post',
    data: data,
    responseType: 'blob'
  })
}
// 单品系数导出
export function productBaseCoeDerive (data) {
  return http({
    url: '/api/productBase/productBaseCoeDerive',
    method: 'post',
    data: data,
    responseType: 'blob'
  })
}
//
// 盖章合同上传列表
export function queryAllByContractUpload (bizId, contractType) {
  return http({
    url: `/api/purchaseContractBase/queryAllByContractUpload/${bizId}/${contractType}`,
    method: 'post'
  })
}
// 盖章合同上传-删除
export function deleteContractFile (saId) {
  return http({
    url: `/api/purchaseContractBase/deleteContractFile/${saId}`,
    method: 'post'
  })
}
// 合同对比
export function contractContrast (bizId, contractType) {
  return http({
    url: `/api/purchaseContractBase/contractContrast/${bizId}/${contractType}`,
    method: 'post'
  })
}
// 合同盖章上传图片
export function addUpload (bizId, contractType, data) {
  return http({
    url: `/api/purchaseContractBase/addUpload/${bizId}/${contractType}`,
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data: data
  })
}
// 合同上传
export function addContract (pcbId) {
  return http({
    url: `/api/purchaseContractBase/addContract/${pcbId}`,
    method: 'post'
  })
}
// 合同下载
export function addPurchaseLog (pcbId) {
  return http({
    url: `/api/purchaseContractBase/addPurchaseLog/${pcbId}`,
    method: 'post'
  })
}
// 附件下载
export function queryContract (bizId, state) {
  return http({
    url: `/api/purchaseContractBase/queryContract/${bizId}/${state}`,
    method: 'post'
  })
}
// 下载模板
export function querySystemAttachmentAddressVo (guid) {
  return http({
    url: `/api/systemAttachment/querySystemAttachmentAddressVo/${guid}`,
    method: 'post'
  })
}

// 预览-导入-产品
export function queryPreview () {
  return http({
    url: '/api/productBase/queryPreview',
    method: 'post'
  })
}
// 系列系数导出
export function orderEnquiryCoeDerive (data) {
  return http({
    url: '/api/orderManualInquiry/orderEnquiryCoeDerive',
    method: 'post',
    data: data,
    responseType: 'blob'
  })
}
// 退回修改 充值
export function updateSupplierRecharge (data) {
  return http({
    url: '/api/supplierRechargeApproval/updateSupplierRecharge',
    method: 'post',
    data: data
  })
}
// 采购跳转到供应商 合同清单
export function contractContractBase (suId, contractState, page, size, data) {
  return http({
    url: `/api/purchaseContractBase/queryBySuIdPurchaseContractBase/${suId}/${contractState}/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 供应商数据-合同清单-数据总览
export function queryPurchaseContractCount (suId) {
  return http({
    url: `/api/purchaseContractBase/queryPurchaseContractCount/${suId}`,
    method: 'get'
  })
}

// 供应商数据 -付款记录
export function queryPayment (suId, page, size, data) {
  return http({
    url: `/api/purchaseContractOtherPayment/queryPayment/${suId}/${page}/${size}`,
    method: 'post',
    data: data

  })
}
export function queryByOrderContractStockupPurchase (page, size, data) {
  return http({
    url: `/api/orderContractStockupPurchase/queryByOrderContractStockupPurchase/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 仓库入库单导出
export function addStorageInstockCoeDerive (data) {
  return http({
    url: '/api/storageInstock/addStorageInstockCoeDerive',
    method: 'post',
    data: data,
    responseType: 'blob'
  })
}
// 仓库入库单导出-已处理
export function addStorageInstockCoeDeriveProcessed (data) {
  return http({
    url: '/api/storageInstock//addStorageInstockCoeDeriveProcessed',
    method: 'post',
    data: data,
    responseType: 'blob'
  })
}
// 仓库导出备货单1
export function addStorageStockCoeDerive (data) {
  return http({
    url: '/api/storageBase/addStorageStockCoeDerive',
    method: 'post',
    data: data,
    responseType: 'blob'
  })
}
// 仓库导出出库单
export function addStorageOutStockCoeDerive (data) {
  return http({
    url: '/api/storageOutstock/addStorageOutStockCoeDerive',
    method: 'post',
    data: data,
    responseType: 'blob'
  })
}
// 仓库打印出库单
export function storageOutStockCoeDerive (soId, data) {
  return http({
    url: `/api/storageOutstock/storageOutStockCoeDerive/${soId}`,
    method: 'post',
    data: data,
    responseType: 'blob'
  })
}
// 仓库-实时库存列表导出
export function addRealShelvesProductCoeDerive (data) {
  return http({
    url: '/api/storageShelvesProduct/addRealShelvesProductCoeDerive',
    method: 'post',
    data: data,
    responseType: 'blob'
  })
}
// 仓储-仓内调拨导出
export function addAllocationCoeDerive (data) {
  return http({
    url: '/api/storageAllocationStock/addAllocationCoeDerive',
    method: 'post',
    data: data,
    responseType: 'blob'
  })
}

// 仓储-盘点导出

export function addAllInventoryContentCoeDerive (data) {
  return http({
    url: '/api/storageInventoryShelves/addAllInventoryContentCoeDerive',
    method: 'post',
    data: data,
    responseType: 'blob'
  })
}

// 仓储产品盈亏记录导出

export function addProfitLossCoeDerive (data) {
  return http({
    url: '/api/storageInventoryShelves/addProfitLossCoeDerive',
    method: 'post',
    data: data,
    responseType: 'blob'
  })
}
// 产品历史出入库导出产品序列号

export function addContentSerialCodeCoeDerive (data) {
  return http({
    url: '/api/storageInventoryBase/addContentSerialCodeCoeDerive',
    method: 'post',
    data: data,
    responseType: 'blob'
  })
}
// 单据历史出入库导出产品序列号

export function addProductSerialCodeCoeDerive (data) {
  return http({
    url: '/api/storageInventoryBase/addProductSerialCodeCoeDerive',
    method: 'post',
    data: data,
    responseType: 'blob'
  })
}
// 历史出入库产品查询-详情页导出
export function addInOutProductDetailCoeDerive (data) {
  return http({
    url: '/api/storageInventoryBase/addInOutProductDetailCoeDerive',
    method: 'post',
    data: data,
    responseType: 'blob'
  })
}
// 历史出入库单据详情-导出

export function addInOutDetailByNumberCoeDerive (data) {
  return http({
    url: '/api/storageInventoryBase/addInOutDetailByNumberCoeDerive',
    method: 'post',
    data: data,
    responseType: 'blob'
  })
}
export function addContractContrast (prpId) {
  return http({
    url: `/api/purchaseRetreatPact/addContractContrast/${prpId}`,
    method: 'post'
  })
}

// 采购清单列表-待审核列表导出清单
export function StockCoeDerive (data) {
  return http({
    url: '/api/orderContractStockupPurchase/StockCoeDerive',
    method: 'post',
    data: data,
    responseType: 'blob'
  })
}

// 采购合同列表-查看操作
export function queryPurchaseTeam (page, size, data) {
  return http({
    url: `/api/purchaseContractBase/queryPurchaseTeam/${page}/${size}`,
    method: 'post',
    data
  })
}
